import React from "react";
import LogTableRows from "./LogTableRows";

const LogTable = ({ list, pageIndex, pageSize, onShowDetail, iTotal }) => (
  <div className="Left808x200 Table-main-new css-table-ds">
    <div className="table-mobile table-mobile-hover">
      <div className="custom-table-wrapper">
        <div className="table-headers" >
          <div className="custom-table-header text-center" style={{ width: "10%" }}>
            <p className="color-do-bold">
              STT
            </p>
            <p className="color-do-bold">
              [{iTotal === 0 ? 0 : iTotal}]
            </p>
          </div>
          <div className="custom-table-header" style={{ width: "20%" }}>
            <p>Người thực hiện</p>
          </div>
          <div className="custom-table-header " style={{ width: "15%" }}>
            <p>Thời gian thực hiện</p>
          </div>
          <div className="custom-table-header text-center" style={{ width: "55%" }}>
            <p>Nội dung</p>
          </div>
        </div>
        <div className="custom-table-body">
          <LogTableRows
            list={list}
            pageIndex={pageIndex}
            pageSize={pageSize}
            onShowDetail={onShowDetail}
          />
        </div>
      </div>
    </div>
  </div>
);

export default LogTable;